import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { WhatsAppButton } from './WhatsAppButton';
export function Process() {
  const steps = [{
    number: '01',
    title: 'Contáctame por WhatsApp'
  }, {
    number: '02',
    title: 'Cuéntame tu situación'
  }, {
    number: '03',
    title: 'Recibe una evaluación inicial'
  }, {
    number: '04',
    title: 'Agendamos tu consulta'
  }, {
    number: '05',
    title: 'Obtén orientación personalizada y recomendaciones'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const stepVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-183">
      <div className="max-w-7xl mx-auto" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-185">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold mb-6" data-id="element-186">
            Tu proceso es <span className="text-gradient-gold" data-id="element-187">simple</span>
          </h2>
        </motion.div>

        <div className="relative max-w-5xl mx-auto" data-id="element-188">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-1/2 left-0 w-full h-0.5 bg-mystic-gold/20 -translate-y-1/2 z-0" data-id="element-189"></div>

          {/* Connecting Line (Mobile/Tablet) */}
          <div className="lg:hidden absolute top-0 left-8 bottom-0 w-0.5 bg-mystic-gold/20 z-0" data-id="element-190"></div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-4 relative z-10" data-id="element-191">
            {steps.map((step, index) => <motion.div key={index} variants={stepVariants} className="flex flex-row lg:flex-col items-center lg:text-center gap-6 lg:gap-4 group" data-id="element-192">
                <div className="w-16 h-16 rounded-full bg-mystic-black border-2 border-mystic-gold flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(212,175,122,0.2)] group-hover:scale-110 group-hover:bg-mystic-gold/10 transition-all duration-300 relative z-10" data-id="element-193">
                  <span className="font-serif text-xl font-bold text-mystic-gold" data-id="element-194">
                    {step.number}
                  </span>
                </div>

                <div className="glass-panel p-4 rounded-xl lg:w-full lg:min-h-[100px] flex items-center justify-center" data-id="element-195">
                  <p className="text-mystic-white/90 font-medium text-sm sm:text-base" data-id="element-196">
                    {step.title}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-20 text-center" data-id="element-197">
          <WhatsAppButton text="Iniciar conversación" variant="primary" message="Hola Maestro Navy, me gustaría iniciar el proceso para una consulta." data-id="element-198" />
        </motion.div>
      </div>
    </section>;
}